import React from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import ReportDataTable from "./ReportDataTable";

const Report = () => {

 
  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Report "
            title="Dashboard"
            subtitle="Report"
          />

          <ReportDataTable  />

        </div>
      </div>
    </div>
  );
};

export default Report;
